import Constants from "expo-constants";
import ENV from "app/utils/ENV";
// import * as Notifications from "expo-notifications";
import React, { useState, useEffect, useRef } from "react";
import { Text, View, Button, Platform } from "react-native";

const notificationHelpers = {
  async registerForPushNotificationsAsync() {
    return null;
  },
};
export default notificationHelpers;
